import React from 'react'
import 'src/components/Relays/Details/sections/Summary.css'
import { RelayDetailModel } from 'src/constants/DataModels'
import StatusTag from 'src/components/shared/StatusTag'
import { formatBridgeId, formatDurationShort, formatPayloadType, formatTime } from 'src/constants/ConversionUtils'
import { BridgeId, FlowType } from 'src/constants/BlockchainConstants'
import Timeline from 'src/components/Relays/Details/sections/Timeline'
import { BlockchainWithIcon } from 'src/components/shared/BlockchainWithIcon'
import FlowTypeTag from 'src/components/shared/FlowTypeTag'
import dayjs from 'dayjs'
import TransitTable from 'src/components/Relays/Details/sections/TransitTable'
import AttributeTable from 'src/components/shared/AttributeTable'
import AttributeRow from 'src/components/shared/AttributeRow'
import { TransferInfo } from 'src/components/shared/TransferInfo'

type Props = {
  title: string
  data: RelayDetailModel
}

const Summary: React.FC<Props> = ({ title, data }) => {
  const {
    payload_type,
    bridge,
    bridge_id,
    bridging_tx_hash,
    source_blockchain,
    source_tx_hash,
    source_transaction,
    destination_blockchain,
    destination_tx_hash,
    status,
    start_block_time,
    end_block_time,
    flow_type,
    events,
    payload,
  } = data
  const isRefunded = status === 'refunded'
  const type = formatPayloadType(bridge_id, flow_type as FlowType, payload_type)
  const isOldBridge = bridge_id === BridgeId.Polynetwork
  const shortDuration = formatDurationShort(start_block_time, end_block_time)
  const blockchain = flow_type === FlowType.In ? source_blockchain : destination_blockchain
  return (
    <div>
      <h4 className="section-title">{title}</h4>
      <div className="summary-content">
        <AttributeTable>
          <AttributeRow name={'Bridge'}>
            {formatBridgeId(bridge_id)}
          </AttributeRow>
          <AttributeRow name={'Blockchain'}>
            <div className="transit">
              <BlockchainWithIcon blockchain={blockchain} />
            </div>
          </AttributeRow>
          <AttributeRow name={'Status'}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
            >
              {StatusTag({ status })}
              {shortDuration && (
                <span style={{ marginLeft: '8px', fontSize: '0.9em', color: '#666' }}>
          ⏲️ {shortDuration}
        </span>
              )}
            </div>
          </AttributeRow>

          <AttributeRow name={'Start Time'}>
            <div className={'summary-time'}>
              {formatTime(source_transaction?.block_time!)}
              <small>({dayjs(source_transaction?.block_time).fromNow()})</small>
            </div>
          </AttributeRow>

          <AttributeRow name={'Type'}>
            <div className={'summary-transfer'}>
              <FlowTypeTag flowType={flow_type} /> {type}
            </div>
            <TransferInfo payload={payload} source_blockchain={source_blockchain}
                          destination_blockchain={destination_blockchain}
            />
          </AttributeRow>

          <AttributeRow name={'Transit'}>
            {isOldBridge ? (
              <TransitTable
                blockchain={source_blockchain}
                hash={source_tx_hash}
                bridgingTxHash={bridging_tx_hash}
                blockchain1={bridge}
                destinationTxHash={destination_tx_hash}
                ibcRefunded={isRefunded}
                destinationBlockchain={destination_blockchain}
              />
            ) : (
              <div>

                <Timeline events={events} relay={data} />
              </div>
            )}
          </AttributeRow>
        </AttributeTable>
      </div>
    </div>
  )
}

export default Summary
